if (!customElements.get('size-converter')) {
  customElements.define(
    'size-converter',
    class SizeConverter extends HTMLElement {
      optionValueSelectionChangeUnsubscriber = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        this.isSyncing = false;
        this.defaultSizeSystem = this.dataset.defaultSizeSystem;
        this.hiddenInput = this.querySelector('input[name="properties[Size]"]');
        this.formID = this.hiddenInput?.getAttribute('form');
        this.form = document.getElementById(this.formID);

        // Update <variant-selects> when size changes within <size-converter> component
        this.addEventListener('change', (event) => {
          if (this.isSyncing || event.target.type !== 'radio') return;

          if (event.target.closest('variant-selects')) return;

          this.updateVariantSelects(event.target);
        });

        // Sync size across all tabs when any size option changes in the <variant-selects> component
        this.optionValueSelectionChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          (event) => {
            if (this.isSyncing) return;

            this.syncSizeAcrossTabs(event.data.selectedOptionValues);
          }
        );

        // Listen for form submit to set converted size property in the hidden input
        this.initFormSubmitListener();
      }

      initFormSubmitListener() {
        if (!this.hiddenInput || !this.form) return;

        this.form.addEventListener('submit', () => {
          this.updateConvertedSizeProperty();
        }, { capture: true });
      }

      updateConvertedSizeProperty() {
        // Find active tab panel
        let activeTabPanel = this.querySelector('.js-tabcontent[aria-hidden="false"]');

        if (!activeTabPanel) {
          this.hiddenInput.value = '';
          return;
        }

        // Check if this is the default tab
        const activeSizeSystem = activeTabPanel.dataset.sizeSystem;

        if (!activeSizeSystem || activeSizeSystem === this.defaultSizeSystem) {
          // Default tab or no size system - clear the property
          this.hiddenInput.value = '';
          return;
        }

        //Find checked radio input and get its value
        const checkedInput = activeTabPanel.querySelector('input[type="radio"]:checked');

        if (checkedInput) {
          this.hiddenInput.value = `${activeSizeSystem} ${checkedInput.value}`;
        } else {
          this.hiddenInput.value = '';
        }
      }

      updateVariantSelects(selectedInput) {
        const optionValueId = selectedInput.dataset.optionValueId;
        if (!optionValueId) return;

        // Find variant-selects component sibling
        const variantSelects = this.querySelector('variant-selects');
        if (!variantSelects) return;


        // Find corresponding input in variant-selects
        const variantInput = variantSelects.querySelector(
          `input[data-option-value-id="${optionValueId}"]`
        );

        if (!variantInput || variantInput.checked) return;

        variantInput.checked = true;
        variantInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      }

      syncSizeAcrossTabs(selectedOptionValues) {
        if (!selectedOptionValues || !Array.isArray(selectedOptionValues)) return;

        this.isSyncing = true;

        selectedOptionValues.forEach((optionValueId) => {
          // Find all radio inputs with this option value ID across all tabs
          // Exclude inputs from variant-selects (only sync size-converter tabs)
          const matchingInputs = Array.from(
            this.querySelectorAll(
              `input[type="radio"][data-option-value-id="${optionValueId}"]`
            )
          ).filter((input) => !input.closest("variant-selects"));

          if (matchingInputs.length > 0) {
            // Check all matching inputs and set them to checked if they are not already checked
            matchingInputs.forEach((input) => {
              if (!input.checked) {
                input.checked = true;
              }
            });
          } else {
            // No match was found, uncheck all radio inputs in all fieldsets (excluding variant-selects)
            const checkedInputs = Array.from(
              this.querySelectorAll(`input[type="radio"]:checked`)
            ).filter((input) => !input.closest("variant-selects"))

            checkedInputs?.forEach((input) => {
              input.checked = false;
            });
          }
        });

        this.isSyncing = false;
      }

      disconnectedCallback() {
        if (this.optionValueSelectionChangeUnsubscriber) {
          this.optionValueSelectionChangeUnsubscriber();
        }
      }
    }
  );
}

